import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider } from "./lib/auth";
import Header from "./components/Header";
import ProtectedRoute from "./components/ProtectedRoute";
import Dashboard from "./pages/Dashboard";
import CreateWizard from "./pages/CreateWizard";
import Recreate from "./pages/Recreate";
import Editor from "./pages/Editor";
import History from "./pages/History";
import AuthPage from "./pages/AuthPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";

function Shell({ children }) {
  return (
    <div className="min-h-screen bg-cream text-ink noise-overlay relative">
      <Header />
      <main className="relative z-10">{children}</main>
      <Toaster position="top-right" />
    </div>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell>
            <Routes>
              <Route path="/login" element={<AuthPage mode="login" />} />
              <Route path="/register" element={<AuthPage mode="register" />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/create" element={<ProtectedRoute><CreateWizard /></ProtectedRoute>} />
              <Route path="/recreate" element={<ProtectedRoute><Recreate /></ProtectedRoute>} />
              <Route path="/editor/:id" element={<ProtectedRoute><Editor /></ProtectedRoute>} />
              <Route path="/history" element={<ProtectedRoute><History /></ProtectedRoute>} />
            </Routes>
          </Shell>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
